// extracted by mini-css-extract-plugin
module.exports = {"warningButtons":"style_warningButtons__3LHCr","new":"style_new__2z-xe"};